import {
  Box,
  Center,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  useToast,
  Button,
} from '@chakra-ui/react';
import React from 'react';

import {
  GetActiveSlackInstallationsDocumentGQLType,
  useDeactivateSlackInstallationsForOrganizationMutation,
} from './slack.gql.generated';
import {
  toastId,
  successToastConfig,
  errorToastId,
  errorToastConfig,
} from '~/packages/common-frontend/constants';
import { getUnexpectedErrorMessage } from '~/packages/common-frontend/utils';

export const DeactivateBorrowerSlackInstallationsConfirmation = ({
  onClose,
  isOpen,
}: {
  onClose: () => void;
  isOpen: boolean;
}) => {
  const toast = useToast();

  const [
    deactivateSlackInstallationsForOrganization,
  ] = useDeactivateSlackInstallationsForOrganizationMutation({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = getUnexpectedErrorMessage(err);
      toast(errorToastConfig);
    },
    refetchQueries: [GetActiveSlackInstallationsDocumentGQLType],
  });

  const handleSubmit = async () => {
    try {
      const {
        data: deactivateSlackInstallationsForOrganizationData,
      } = await deactivateSlackInstallationsForOrganization();

      if (
        deactivateSlackInstallationsForOrganizationData &&
        deactivateSlackInstallationsForOrganizationData.deactivateSlackInstallationsForOrganization &&
        !toast.isActive(toastId)
      ) {
        onClose();
        const response =
          deactivateSlackInstallationsForOrganizationData
            .deactivateSlackInstallationsForOrganization.response;
        successToastConfig.title = response;
        toast(successToastConfig);
      }
    } catch (err: any) {
      if (!toast.isActive(errorToastId)) {
        errorToastConfig.title = `Error deactivating slack installation for organization. Please try again.`;
        toast(errorToastConfig);
      }
      throw err;
    }
  };

  return (
    <Box>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Deactivate Slack channels</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text marginBottom="20px">
              Please confirm that you would like to deactivate Finley from all
              of your Slack channels.
            </Text>
            <Center mt="30px">
              <HStack spacing="20px">
                <Button
                  type="submit"
                  variant="primary"
                  colorScheme="red"
                  width="fit-content"
                  onClick={handleSubmit}
                >
                  Deactivate
                </Button>
                <Button
                  variant="secondary"
                  colorScheme="gray"
                  width="fit-content"
                  onClick={onClose}
                >
                  Cancel
                </Button>
              </HStack>
            </Center>
            <Box height="25px" />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
